module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.segmentClasses
  }, [_c('div', {
    class: _vm.statisticClasses
  }, [_c('div', {
    staticClass: "value"
  }, [(_vm.icon) ? _c('i', {
    class: _vm.iconClasses
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0f12b7db"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/croud-vue-semantic/src/Statistic.vue
// module id = 1443
// module chunks = 1